module.exports = __webpack_public_path__ + "static/media/logo-doro-landscape.95bcee67.svg";